import React, { useEffect, useState } from "react";

import Image from "../../components/image";
import ApplyButton from "../../components/shared/applyButton";
import { useTheme } from "../../context/ThemeContext";
import { useProgramFees } from "../../hooks/useProgramFees";
import { Link } from "../../utils/customLink";
import {
  formatCurrencyAmount,
  shortcodePreProcessor
} from "../../utils/formatContent";

const ScholarshipBanner = ({
  scholarships,
  scholarshipBackgroundImage,
  scholarshipFeatureImage,
  scholarshipTitle,
  scholarshipDescription,
  scholarshipCtaLink,
  scholarshipCtaLabel = "Apply now"
}) => {
  const { currentSiteMeta } = useTheme();

  const programFees = useProgramFees();

  const currencyToUse = currentSiteMeta?.currency
    ? currentSiteMeta.currency.toLowerCase()
    : process.env.GATSBY_PROJECT_CURRENCY ?? "gbp";

  const exclusiveDiscount =
    scholarships.find(
      (discount) => discount.exclusiveDiscountCurrency === currencyToUse
    ) ?? [];

  const scholarshipAmount =
    exclusiveDiscount?.exclusiveDiscountAmount ?? "1000";

  const scholarshipAmountDisplay = formatCurrencyAmount({
    currentSiteMeta,
    currency:
      currentSiteMeta?.currency ?? process.env.GATSBY_PROJECT_CURRENCY ?? "gbp",
    amount: scholarshipAmount
  });

  const scholarshipDisplayDescription = scholarshipDescription?.replace(
    "EXCLUSIVE_OFFER",
    scholarshipAmountDisplay
  );

  const scholarshipDisplayTitle = scholarshipTitle?.replace(
    "EXCLUSIVE_OFFER",
    scholarshipAmountDisplay
  );

  const formattedTitle = shortcodePreProcessor({
    programFees,
    currentSiteMeta,
    description: scholarshipDisplayTitle
  });

  const formattedDesc = shortcodePreProcessor({
    programFees,
    currentSiteMeta,
    description: scholarshipDisplayDescription
  });

  const gaEventScholarshipButtonClick = () => {
    typeof window !== "undefined" &&
      window?.dataLayer?.push({
        event: "homepage_scholarship_banner",
        event_category: "button_click",
        event_label: "homepage_scholarship_banner"
      });
  };

  return (
    <section
      id="scholarship-banner"
      key="scholarship-banner"
      className="flex flex-col items-center justify-center px-2 mx-auto bg-yellow-lighter dark:gvi-dark-gray-bg"
    >
      <div
        className="container w-full px-2 py-8 sm:py-16 sm:w-4/5"
        style={{
          backgroundImage: `${
            scholarshipBackgroundImage
              ? `url(${scholarshipBackgroundImage})`
              : "none"
          }`
        }}
      >
        <div className="rounded-xs flex items-center flex-col sm:flex-row sm:h-full gvi-box-shadow bg-white dark:gvi-light-gray-bg">
          <div className="rounded-t-[5px] md:rounded-l-[5px] md:rounded-r-[0] sm:h-auto h-50 w-full sm:w-[38%]">
            <Image
              imageAlt={""}
              image={scholarshipFeatureImage}
              imageClass="xs:object-contain sm:object-cover xs:object-center md:object-center"
              sourceUrl={
                scholarshipFeatureImage?.sourceUrl || scholarshipFeatureImage
              }
            />
          </div>

          <div className="flex flex-col items-start flex-1 w-full gap-4 px-4 bg-transparent bg-white rounded-b md:pl-20 dark:gvi-light-gray-bg py-7">
            <div className="w-full">
              <h2
                className="text-[26px] sm:text-xlrg-sm"
                dangerouslySetInnerHTML={{ __html: formattedTitle }}
              />
            </div>
            <div className="sm:py-1">
              <div
                className="text-mob text-black-lighter dark:text-gray-generic"
                dangerouslySetInnerHTML={{
                  __html: formattedDesc
                }}
              />
            </div>
            <div className="md:block w-full md:w-3/5 min-w-[10rem]">
              <div className="flex items-center justify-between">
                <div className="w-full md:w-1/2">
                  <ApplyButton
                    to={scholarshipCtaLink}
                    buttonStyle="group relative z-10 flex flex-row items-center justify-center px-2 py-2 rounded-full dark:rounded-sm text-white dark:text-gray-darker bg-red-light dark:bg-green-standard hover:bg-black-lighter dark:hover:bg-white "
                    ctaLabel={scholarshipCtaLabel}
                    labelClass="text-base leading-genericCta font-bold pr-2"
                    arrowClass="stroke-white hover:stroke-black-lighter dark:stroke-gray-darker"
                    onClick={gaEventScholarshipButtonClick}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default ScholarshipBanner;
